import axios from "axios";
import { API } from "../../utils";
const instance = axios.create();

export const getProducts = async () => {
  return instance.get(`${API}/product`);
};
